// extracted by mini-css-extract-plugin
export default {"wrap":"gC-z","backNav":"hC-z","item":"iC-z","disabled":"jC-z","submitBtn":"kC-z"};